import React, { Component } from "react";

export class LoadScreen extends Component {
  render() {
    return (
      <div className="ui-g-12">
        <div className="splash-screen" style={{ background: "#043066" }}>
          <div
            className="splash-container"
            style={{ paddingTop: "10em", paddingBottom: "10em" }}
          >
            <div>
              <img
                style={{
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "99%"
                }}
                src="/assets/layout/images/business/logo.png"
                alt=""
              />
            </div>
            <div className="load-bar">
              <div className="bar" />
              <div className="bar" />
              <div className="bar" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/LoadScreen.js